export default __webpack_public_path__ + "static/media/goodLuck.2b05eea2.mp3";